import { ChangeEvent, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { createFile } from '../cms/FileService';
import { apiRequest } from '../utils/authConfig';
import { useMsal, account } from '../utils/authContext';
import LoadingButton from './LoadingButton';

interface DUFile extends File {
    lastModifiedDate: Date;
}

interface OnUploadCompleteFunc {
    (): any;
}

interface OnErrorFunc {
    (error: string): any;
}

interface UploadProps {
    endpoint: string;
    onUploadComplete?: OnUploadCompleteFunc;
    onError?: OnErrorFunc;
    parentFolder?: string;
    label?: string;
    className?: string;
    disabled?: boolean;
    disabledMessage?: string;
    validated?: boolean;
    required?: boolean;
}

const Uploader = (props: UploadProps) => {
    const endpoint = props.endpoint;
    const onUploadComplete = props.onUploadComplete;
    const onError = props.onError;
    const { getToken } = useMsal();
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFile, setSelectedFile]: [DUFile | undefined, any] = useState();
    const fileInput = useRef<HTMLInputElement>(null);
    const label = props.label ? props.label : 'Upload a File';
    const cssClasses = props.className ? props.className : 'pt-4 pb-4';

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setSelectedFile(event.target.files[0]);
        }
    };
    const fileData = () => {
        const file = selectedFile;
        if (!file) {
            return null;
        } else {
            return (<span>{file.name}</span>);
        }
    };
    const handleUpload = async () => {
        const file = selectedFile;
        const current = props.parentFolder;
        if (!file) {
            return;
        }
        setIsUploading(true);
        const formData = new FormData();
        formData.append(
            "file",
            file,
            file.name
        );
        if (current) {
            formData.append(
                "folder",
                encodeURIComponent(current + '/'),
            );
        }
        const args = { ...apiRequest, account };

        try {
            await createFile(formData, getToken, args, endpoint);
            setIsUploading(false);
            setSelectedFile(null);
            const fileToUpload = fileInput?.current;
            if (fileToUpload) {
                fileToUpload.value = '';
            }
            if (onUploadComplete) {
                onUploadComplete();
            }
        } catch (err: any) {
            setIsUploading(false);
            if (onError) {
                onError(err.message);
            } else {
                console.error(err);
            }
        }
    }

    return (<div className={cssClasses}>
        {!selectedFile && <>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                ref={fileInput}
                onChange={handleChange}
                disabled={props?.disabled}
                isInvalid={props?.disabled && props?.validated}
                required={props?.required}
                type="file"
                className="info"
            /></>}
        {props?.disabledMessage && <Form.Control.Feedback type="invalid">
            {props.disabledMessage}
        </Form.Control.Feedback>}
        {selectedFile && <><LoadingButton loading={isUploading} className="btn btn-primary ms-1" onClick={handleUpload}> Upload </LoadingButton> {fileData()}</>}

    </div>);
}
export default Uploader;